import { http, type HttpOptions } from './httpClient'
import type {
  InviteMemberRequest,
  Paginated,
  UpdateMemberRequest,
  WorkspaceMember,
  WorkspaceRole,
} from './types'

export interface MemberListParams {
  limit?: number
  offset?: number
  q?: string
  role?: WorkspaceRole
  is_active?: 'true' | 'false' | 'all'
  ordering?: string
}

export const memberApi = {
  list: (workspaceId: number, params: MemberListParams = {}, opts?: HttpOptions) =>
    http.get<Paginated<WorkspaceMember>>(`/api/workspaces/${workspaceId}/members/`, {
      ...opts,
      query: { ...opts?.query, ...params },
    }),

  invite: (workspaceId: number, body: InviteMemberRequest, opts?: HttpOptions) =>
    http.post<WorkspaceMember, InviteMemberRequest>(
      `/api/workspaces/${workspaceId}/members/`,
      body,
      opts,
    ),

  patch: (workspaceId: number, memberId: number, body: UpdateMemberRequest, opts?: HttpOptions) =>
    http.patch<WorkspaceMember, UpdateMemberRequest>(
      `/api/workspaces/${workspaceId}/members/${memberId}/`,
      body,
      opts,
    ),

  remove: (workspaceId: number, memberId: number, opts?: HttpOptions) =>
    http.delete<void>(`/api/workspaces/${workspaceId}/members/${memberId}/`, opts),
}
